/**
 * Collapsible sidebar/drawer section helpers (path-based for web).
 */

export function isPathInNavSection(section, pathname) {
  if (!section?.items?.length || !pathname) return false;
  return section.items.some((item) => {
    if (pathname === item.href) return true;
    if (item.href !== '/' && pathname.startsWith(`${item.href}/`)) return true;
    return false;
  });
}

export function isAccountNavPath(pathname) {
  return pathname === '/profile' || pathname === '/settings';
}

export function buildNavSectionOpenState({
  sections,
  pathname,
  saved = {},
  includeAccount = true,
}) {
  const state = {};
  for (const section of sections) {
    if (typeof saved[section.id] === 'boolean') {
      state[section.id] = saved[section.id];
    } else {
      state[section.id] = isPathInNavSection(section, pathname);
    }
  }
  if (includeAccount) {
    state.account =
      typeof saved.account === 'boolean' ? saved.account : isAccountNavPath(pathname);
  }
  const hasSaved = Object.keys(saved).length > 0;
  const anyOpen = Object.values(state).some(Boolean);
  if (!hasSaved && !anyOpen && sections[0]?.id) {
    state[sections[0].id] = true;
  }
  return state;
}

export function mergeNavSectionOpenForActiveRoute(state, sections, pathname, { includeAccount = true } = {}) {
  const next = { ...state };
  let changed = false;
  for (const section of sections) {
    if (isPathInNavSection(section, pathname) && !next[section.id]) {
      next[section.id] = true;
      changed = true;
    }
  }
  if (includeAccount && isAccountNavPath(pathname) && !next.account) {
    next.account = true;
    changed = true;
  }
  return changed ? next : state;
}
